// just a simple hello world with an example navigation link to another page
// use Link from gatsby to navigate through pages
import React, {useState, useEffect} from "react"
import { Link } from "gatsby"
//import Contact from "../components/contact"
import Layout from "../components/layout"
//import "../styles/howtomakemotorclaims.css"
import langBM from "../languages/bm"
import langEN from "../languages/en"

const LostPage = () => {
  const [isOpenContact, setOpenContact] = useState(false)
  const [lang, setLang] = useState(langEN)

  useEffect(() => {    
    let cookieLang 
    try {
      cookieLang = document.cookie.split("; ").find(row => row.startsWith("lang=")).split("=")[1]
      if (cookieLang === "BM") {
    	   setLang(langBM)
	    }else{
        setLang(langEN)
      }
    } catch (err) {
      setLang(langEN)
    }
    
  }, [])

  return <Layout pageTitle="ESi Motor Claims" lang={lang}>

	{/* Content for Motor Claims  */}
    <div class="container">
        <div class="faq-bg mt-1 mobile-mt_none" styles="padding-top: 10px; padding-bottom: 80px;">
            <div class="row">
                <div class="text-center col-md-10 mb-5 offset-md-1">
                    <img className="d-block w-100 img-fluid" src={"/cimb/staff/images/esi/ESi Claims Banner.png"} alt="Banner" />
                </div>

                <div class="col-md-10 mb-5 offset-md-1">
                    <span styles="font-size:18px;"><span styles="color#c0392b;">
                        <strong>Fast claim approval and direct settlement</strong>
                    </span></span>
                    <br />

                    Payment of up to RM5,000 for private car own damage claim.<br />
                    Please call 1800 88 9933 for more details.<br />
                    <br />
                    Read the full Terms and Conditions <a href="https://www.berjayasompo.com.my/_uploads/files/claims/ESi-Motor%20Claims/TC_SOMPO%20ESi-Motor%20Claims_Final%20as%20of%2021042020.pdf" target="_blank">here</a>.<br />
                    Read the full General Frequently Asked Questions (FAQ) <a href="https://www.berjayasompo.com.my/_uploads/files/claims/ESi-Motor%20Claims/FAQs_SOMPO%20ESi-Motor%20Claims_Final%20as%20of%2021042020.pdf" target="_blank">here</a>.<br />
                    <br />
                    Here are the general guidelines to adopt in the event of a possible claim happening:<br />
                    <br />
                </div>

                <br />
                <div class="col-md-10 mb-1 offset-md-1">
                    <span styles="font-size:20px;"><strong>Type of Accidents:</strong></span>
                </div>
                <div class="text-center col-md-10 mb-5 offset-md-1">
                    <img className="d-block w-100 img-fluid" src={"/cimb/staff/images/esi/02.jpg"} alt="Banner" />
                </div>

                {/* Step 1 */}
                <br />
                <div class="col-md-10 mb-1 offset-md-1">
                    <span styles="font-size:20px;"><strong>Step 1:</strong></span>
                    <ul>
                        <li>When an accident happens, lodge a police report at the nearest police station within 24 hours from the time of the accident. Then, call us at 1800 88 9933 (Monday to Friday from 8.30 am -5.00 pm, excluding public holidays) within 24 hours and request for a video call inspection/assessment or drive the vehicle to our nearest Berjaya Sompo Office for inspection/assessment.</li>
                    </ul>
                </div>
                <div class="text-center col-md-10 mb-5 offset-md-1">
                    <img className="d-block w-100 img-fluid" src={"/cimb/staff/images/esi/03.jpg"} alt="Banner" />
                </div>

                {/* Step 2 */}
                <br />
                <div class="col-md-10 mb-1 offset-md-1">
                    <span styles="font-size:20px;"><strong>Step 2:</strong></span>
                    <ul>
                        <li>Berjaya Sompo will process the approval of the claim within 1 hour after completion of&nbsp;inspection of the vehicle. After the Inspection, Berjaya Sompo will issue a letter&nbsp;which states the cost of repair approved by Berjaya Sompo as the full and final settlement of the claim.</li>
                    </ul>
                </div>
                <div class="text-center col-md-10 mb-5 offset-md-1">
                    <img className="d-block w-100 img-fluid" src={"/cimb/staff/images/esi/04.jpg"} alt="Banner" />
                </div>

                {/* Step 3 */}
                <br />
                <div class="col-md-10 mb-1 offset-md-1">
                    <span styles="font-size:20px;"><strong>Step 3:</strong></span>
                    <ul>
                        <li>Upon receiving the Acceptance of the Offer Letter by Berjaya Sompo, we will proceed to make payment to the policyholder’s account within 1 hour.</li>
                    </ul>
                </div>
                <div class="text-center col-md-10 mb-5 offset-md-1">
                    <img className="d-block w-100 img-fluid" src={"/cimb/staff/images/esi/05.jpg"} alt="Banner" />
                </div>

                {/* Last  */}
                <br />
                <br />
                <div class="col-md-10 mb-1 offset-md-1">
                    Read the full Terms and Conditions <a href="https://www.berjayasompo.com.my/_uploads/files/claims/ESi-Motor%20Claims/TC_SOMPO%20ESi-Motor%20Claims_Final%20as%20of%2021042020.pdf" target="_blank">here</a>.<br />
                    Read the full General Frequently Asked Questions (FAQ) <a href="https://www.berjayasompo.com.my/_uploads/files/claims/ESi-Motor%20Claims/FAQs_SOMPO%20ESi-Motor%20Claims_Final%20as%20of%2021042020.pdf" target="_blank">here</a>.
                </div>
            </div>

        </div>
    </div>
    

{/* <Contact 
    isOpen={isOpenContact} 
    toggle={() => setOpenContact(v => !v)}
  /> */}

</Layout>
}
export default LostPage